import React from 'react';
import { HPWrapper } from './style';
import { useSelector } from 'react-redux';


const HPItem = ({ 
  item: {HealthProvider, Name, cityDetails}, 
  onClick,
  selected,
  id,
  borderColor
}) => {
const {webConfig} = useSelector(state => state.core);

return (
    <HPWrapper 
        key={HealthProvider}
        onClick={() => onClick(HealthProvider)}
        selected={HealthProvider === selected}
        id={id}
        borderColor={borderColor}
    >
        {webConfig.lang !== 'fa'
        ?
        <>
        {Name} {cityDetails?.Slug && `(${cityDetails?.Slug})`}
        </>
        :
        <>
        {Name} {cityDetails?.Title && `(${cityDetails?.Title})`}
        </>
        }
    </HPWrapper>
)
};

export default HPItem;